import { toNatural } from "../../lib/utils";

export const breadcrumbsJson = (path: string) => {
  const formatted = path.replace(/https?:\/\//g, () => "");
  const [basePath, ...splits] = formatted.split("/");
  const linkData = splits.map((item, pos, arr) => {
    const start: string = `https://${basePath}/`;
    const prev: string = `${start}/${arr.slice(0, pos).join("/") + "/"}${item}`;
    return [prev, item];
  });
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: linkData.map(([path, name], i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: toNatural(name),
      item: path,
    })),
  };
};
